const ENV_URL = process.env.REACT_APP_BACKEND_URL;

// Same-origin API on any deployed host (custom domain or backup platform URL); env URL for local dev.
const isLocal = () => ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const BACKEND_URL =
  typeof window !== "undefined" && !isLocal() ? window.location.origin : ENV_URL;

export const PRIMARY_URL = "https://katwirelabs-neuraldeck.com";
export const BACKUP_URL = "https://ai-beat-sync.emergent.host";
